module.exports = __webpack_public_path__ + "media/apps/hero-gif-e13f4202.jpg";